import { useContext } from './Context'
import { routesDef } from '../../config/routes'
import { ConfirmOrderButton as ConfirmOrderButtonCore } from '@ztechapps/order.webui'
import React from 'react'
import { useHistory } from '@ztechapps/common.hook'

export const ConfirmOrderButton = () => {
  const history = useHistory()
  const { document } = useContext()
  const onClickConfirmButton = () => {
    history.push(routesDef.CheckoutMessageSent.altPath({ _id: document?._id }))
  }

  return <ConfirmOrderButtonCore onClick={onClickConfirmButton} />
}
